import axios from "axios";
import {createURL} from "./client";

// getServerTime получает серверное время для таймеров восстановления.
export async function getServerTime() {
    const url = new URL(createURL("/api/time"));
    url.searchParams.set("_ts", `${Date.now()}-${Math.random().toString(16).slice(2)}`);

    return await axios.get(url.toString());
}
